<cll-card appearance="outlined" *ngIf="_ruleModel">
    <cll-card-header>
        <cll-card-title>
            <app-input-text placeholder="Give this rule a name"
                            label="Rule name"
                            style="margin: 0"
                            [(ngModel)]="_ruleModel.name"
                            (ngModelChange)="_onModelChanged()"
                            [ngModelOptions]="{ updateOn: 'blur' }"
                            [disabled]="disabled" />
        </cll-card-title>

        <cll-card-header-actions>
            <button cll-button (click)="remove.emit()">
                <cll-icon>clear</cll-icon>
            </button>
        </cll-card-header-actions>
    </cll-card-header>

    <h5 class="form-section-header">
        Conditions

        <button cll-icon-button
                class="float-right"
                (click)="addCondition()"
                [disabled]="disabled"
                cllTooltip="Add condition">
            <cll-icon>add</cll-icon>
        </button>
    </h5>

    <div *ngFor="let condition of _ruleModel.conditions"
         class="form-row">

        <div class="app-contract-rule__action">
            <button cll-icon-button
                    (click)="removeCondition(condition)"
                    [disabled]="disabled"
                    cllTooltip="Remove this condition">
                <cll-icon>clear</cll-icon>
            </button>
        </div>

        <app-select-form-field label="Source"
                               appearance="standard"
                               class="flex-25"
                               [(ngModel)]="condition.source"
                               (ngModelChange)="_onModelChanged()"
                               [disabled]="disabled"
                               [options]="[{ label: 'Date Range', value: 'date_range' }]" />

        <app-select-form-field label="Operator"
                               appearance="standard"
                               class="flex-25"
                               [(ngModel)]="condition.operator"
                               (ngModelChange)="_onModelChanged()"
                               [disabled]="disabled"
                               [options]="[{ label: 'contains', value: 'contains' }]" />

        <app-select-form-field label="Value"
                               appearance="standard"
                               class="flex-25"
                               [(ngModel)]="condition.value"
                               (ngModelChange)="_onModelChanged()"
                               [disabled]="disabled"
                               [options]="conditionValueOptions" />

        <div class="flex-25" *ngIf="condition.value === conditionValue.specialDay">
            <app-special-day-select label="Special Day"
                                    [(ngModel)]="condition.value_options.special_day_id"
                                    (ngModelChange)="_onModelChanged()"
                                    [disabled]="disabled" />
        </div>
    </div>

    <hr class="app-separator">

    <h5 class="form-section-header">
        Actions

        <button class="float-right"
                cll-icon-button
                (click)="addAction()"
                [disabled]="disabled"
                cllTooltip="Add action">
            <cll-icon>add</cll-icon>
        </button>
    </h5>

    <ng-container class="form-row"
                  *ngFor="let action of _ruleModel.actions">
        <div class="form-row" *ngIf="_ruleModel.conditions.length">
            <div class="app-contract-rule__action">
                <button cll-icon-button
                        (click)="removeAction(action)"
                        [disabled]="disabled"
                        cllTooltip="Remove this action">
                    <cll-icon>clear</cll-icon>
                </button>
            </div>

            <app-select-form-field label="Source"
                                   appearance="standard"
                                   class="flex-25"
                                   [(ngModel)]="action.source"
                                   (ngModelChange)="_onModelChanged()"
                                   [disabled]="disabled"
                                   [options]="[{ label: 'Line Item', value: 'line_item' }]" />

            <app-select-form-field label="Operator"
                                   appearance="standard"
                                   class="flex-25"
                                   [(ngModel)]="action.operator"
                                   (ngModelChange)="_onModelChanged()"
                                   [disabled]="disabled"
                                   [options]="[
                                            { label: 'add', value: 'add' },
                                            { label: 'subtract', value: 'subtract' },
                                            { label: 'set', value: 'set' }
                                        ]" />

            <app-select-form-field label="Value"
                                   appearance="standard"
                                   class="flex-25"
                                   [(ngModel)]="action.value"
                                   (ngModelChange)="_onModelChanged()"
                                   [disabled]="disabled"
                                   [options]="[{ label: 'Amount', value: 'currency' }]" />

            <div class="flex-25">
                <app-input-currency
                    *ngIf="action.value === 'currency'"
                    label="Amount"
                    appearance="standard"
                    [(ngModel)]="action.value_options.amount"
                    (ngModelChange)="_onModelChanged()"
                    [ngModelOptions]="{ updateOn: 'blur' }"
                    [disabled]="disabled" />
            </div>
        </div>
    </ng-container>
</cll-card>
